{
  "button_add_more_images": [
    {
      "type": 0,
      "value": "Mehr Bilder hinzufügen"
    }
  ],
  "button_approve": [
    {
      "type": 0,
      "value": "Bestätigen"
    }
  ],
  "button_back": [
    {
      "type": 0,
      "value": "Zurück"
    }
  ],
  "button_back_to_cart": [
    {
      "type": 0,
      "value": "Gallery"
    }
  ],
  "button_back_to_login": [
    {
      "type": 0,
      "value": "Zurück zur Startseite"
    }
  ],
  "button_bill_to_room": [
    {
      "type": 0,
      "value": "Aufs Zimmer schreiben"
    }
  ],
  "button_buy_more": [
    {
      "type": 0,
      "value": "Mehr kaufen"
    }
  ],
  "button_cancel": [
    {
      "type": 0,
      "value": "Absagen"
    }
  ],
  "button_close": [
    {
      "type": 0,
      "value": "Schließen"
    }
  ],
  "button_complete_purchase": [
    {
      "type": 0,
      "value": "Kauf Abschließen"
    }
  ],
  "button_continue": [
    {
      "type": 0,
      "value": "Weiter"
    }
  ],
  "button_credit_or_debit_card": [
    {
      "type": 0,
      "value": "Kredit- oder Debitkarte"
    }
  ],
  "button_customer_login": [
    {
      "type": 0,
      "value": "Back to Customer Login"
    }
  ],
  "button_done": [
    {
      "type": 0,
      "value": "FERTIG"
    }
  ],
  "button_download": [
    {
      "type": 0,
      "value": "Herunterladen"
    }
  ],
  "button_edit_order": [
    {
      "type": 0,
      "value": "Bestellung bearbeiten"
    }
  ],
  "button_enter": [
    {
      "type": 0,
      "value": "Eingeben"
    }
  ],
  "button_forgot": [
    {
      "type": 0,
      "value": "Vergessen"
    }
  ],
  "button_got_it": [
    {
      "type": 0,
      "value": "Verstanden"
    }
  ],
  "button_image_view_next": [
    {
      "type": 0,
      "value": "Weiter(Pfeil rechts)"
    }
  ],
  "button_image_view_previous": [
    {
      "type": 0,
      "value": "Zurück(Pfeil links)"
    }
  ],
  "button_image_view_zoom": [
    {
      "type": 0,
      "value": "Vergrößern/verkleinern"
    }
  ],
  "button_log_out": [
    {
      "type": 0,
      "value": "Abmelden"
    }
  ],
  "button_login": [
    {
      "type": 0,
      "value": "Einloggen"
    }
  ],
  "button_lookup_gallery": [
    {
      "type": 0,
      "value": "Galerie ansehen"
    }
  ],
  "button_more_images": [
    {
      "type": 0,
      "value": "Mehr Bilder"
    }
  ],
  "button_new_order": [
    {
      "type": 0,
      "value": "Neue Bestellung"
    }
  ],
  "button_ok": [
    {
      "type": 0,
      "value": "OK"
    }
  ],
  "button_price_guide": [
    {
      "type": 0,
      "value": "Preisübersicht"
    }
  ],
  "button_print": [
    {
      "type": 0,
      "value": "Drucken"
    }
  ],
  "button_process": [
    {
      "type": 0,
      "value": "Vorgang"
    }
  ],
  "button_purchase": [
    {
      "type": 0,
      "value": "Kauf"
    }
  ],
  "button_refresh": [
    {
      "type": 0,
      "value": "Aktualisieren"
    }
  ],
  "button_remove": [
    {
      "type": 0,
      "value": "Entfernen"
    }
  ],
  "button_remove_prints": [
    {
      "type": 0,
      "value": "Drucke entfernen"
    }
  ],
  "button_review_and_purchase": [
    {
      "type": 0,
      "value": "Überprüfen und kaufen"
    }
  ],
  "button_review_cart": [
    {
      "type": 0,
      "value": "Cart"
    }
  ],
  "button_select": [
    {
      "type": 0,
      "value": "Auswählen"
    }
  ],
  "button_selected_print_sizes": [
    {
      "type": 0,
      "value": "Ausgewählte Druckgrößen ("
    },
    {
      "type": 1,
      "value": "quantity"
    },
    {
      "type": 0,
      "value": ")"
    }
  ],
  "button_send_link": [
    {
      "type": 0,
      "value": "Link senden"
    }
  ],
  "button_send_links": [
    {
      "type": 0,
      "value": "Links senden"
    }
  ],
  "button_share": [
    {
      "type": 0,
      "value": "Teilen"
    }
  ],
  "button_stay": [
    {
      "type": 0,
      "value": "Bleiben"
    }
  ],
  "button_stripe_reader": [
    {
      "type": 0,
      "value": "Stripe Reader"
    }
  ],
  "button_tilby": [
    {
      "type": 0,
      "value": "Tilby"
    }
  ],
  "button_toggle_access_codes": [
    {
      "type": 0,
      "value": "Toggle Access Codes"
    }
  ],
  "button_view_gallery": [
    {
      "type": 0,
      "value": "Galerie ansehen"
    }
  ],
  "button_view_my_gallery": [
    {
      "type": 0,
      "value": "View My Gallery"
    }
  ],
  "button_view_receipt": [
    {
      "type": 0,
      "value": "View Receipt"
    }
  ],
  "cart_add_image_no_cost": [
    {
      "type": 0,
      "value": "Sie können kostenlos weitere Bilder hinzufügen"
    }
  ],
  "cart_apply_coupon": [
    {
      "type": 0,
      "value": "Anwenden"
    }
  ],
  "cart_buy_all_at_price": [
    {
      "type": 0,
      "value": "Preis für den Kauf von allen ist "
    },
    {
      "type": 1,
      "value": "amount"
    }
  ],
  "cart_buy_all_discount_description": [
    {
      "type": 0,
      "value": "Alle Bilder für "
    },
    {
      "type": 1,
      "value": "price"
    },
    {
      "type": 0,
      "value": " kaufen"
    }
  ],
  "cart_buy_all_discount_label": [
    {
      "type": 1,
      "value": "price"
    },
    {
      "type": 0,
      "value": " für alle"
    }
  ],
  "cart_cart_details": [
    {
      "type": 0,
      "value": "Details zum Warenkorb"
    }
  ],
  "cart_cart_total": [
    {
      "type": 0,
      "value": "Übersicht Warenkorb"
    }
  ],
  "cart_checkout": [
    {
      "type": 0,
      "value": "Kasse"
    }
  ],
  "cart_coupon_code": [
    {
      "type": 0,
      "value": "Gutscheincode"
    }
  ],
  "cart_coupon_code_instructions": [
    {
      "type": 0,
      "value": "Please enter your coupon code to apply it to your order."
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "Click continue to proceed to checkout"
    }
  ],
  "cart_credit_debit_card": [
    {
      "type": 0,
      "value": "Kredit- oder Debitkarte"
    }
  ],
  "cart_digital_image": [
    {
      "type": 0,
      "value": "Digitale Bild(er)"
    }
  ],
  "cart_digitals": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Digitale Bild"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Digitales Bilder"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "quantity"
    }
  ],
  "cart_digitals_and_prints": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " digitales Bild"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " digitale Bilder"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "digitals"
    },
    {
      "type": 0,
      "value": " & "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Druck"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Drucke"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "quantity"
    }
  ],
  "cart_discount_label": [
    {
      "type": 0,
      "value": "Mehr Bilder kaufen und Rabatt erhalten"
    }
  ],
  "cart_image_free_of_charge": [
    {
      "type": 0,
      "value": "Dieses "
    },
    {
      "type": 1,
      "value": "imageDesc"
    },
    {
      "type": 0,
      "value": " ist kostenlos."
    }
  ],
  "cart_link_to_gallery": [
    {
      "type": 0,
      "value": "Ein Link zu Ihrer Galerie wurde an "
    },
    {
      "type": 1,
      "value": "email"
    },
    {
      "type": 0,
      "value": " gesendet"
    }
  ],
  "cart_no_photos_available": [
    {
      "type": 0,
      "value": "No images are currently available. If you just had photos taken, they will be available here soon so check back.  If you have not yet had photos taken, please see a photographer to get started"
    }
  ],
  "cart_no_selected_image": [
    {
      "type": 0,
      "value": "Bitte wählen Sie ein Bild/Bilder aus, das/die Sie kaufen möchten"
    }
  ],
  "cart_on_date": [
    {
      "type": 0,
      "value": "am "
    },
    {
      "type": 1,
      "value": "date"
    }
  ],
  "cart_packages_discount_description": [
    {
      "type": 0,
      "value": "Erhalte "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Bild"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Bilder"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "quantity"
    },
    {
      "type": 0,
      "value": " für "
    },
    {
      "type": 1,
      "value": "price"
    }
  ],
  "cart_packages_discount_description_all": [
    {
      "type": 0,
      "value": "Alle Bilder für "
    },
    {
      "type": 1,
      "value": "price"
    }
  ],
  "cart_packages_discount_description_range": [
    {
      "type": 1,
      "value": "minimum"
    },
    {
      "type": 0,
      "value": "-"
    },
    {
      "type": 1,
      "value": "maximum"
    },
    {
      "type": 0,
      "value": " Bilder für "
    },
    {
      "type": 1,
      "value": "price"
    }
  ],
  "cart_packages_discount_label": [
    {
      "type": 1,
      "value": "quantity"
    },
    {
      "type": 0,
      "value": " für "
    },
    {
      "type": 1,
      "value": "price"
    }
  ],
  "cart_packages_discount_label_range": [
    {
      "type": 1,
      "value": "minimum"
    },
    {
      "type": 0,
      "value": "-"
    },
    {
      "type": 1,
      "value": "maximum"
    },
    {
      "type": 0,
      "value": " für "
    },
    {
      "type": 1,
      "value": "price"
    }
  ],
  "cart_price_guide": [
    {
      "type": 0,
      "value": "Preisübersicht"
    }
  ],
  "cart_price_guide_notes": [
    {
      "type": 0,
      "value": "Preise finden Sie in der Preisübersicht"
    }
  ],
  "cart_prints": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Druck"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Drucke"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "quantity"
    }
  ],
  "cart_purchase": [
    {
      "type": 0,
      "value": "Kauf"
    }
  ],
  "cart_purchase_unavailable": [
    {
      "type": 0,
      "value": "Mobile purchasing is unavailable.  Please visit the on-site kiosk to view"
    }
  ],
  "cart_purchased": [
    {
      "type": 0,
      "value": "Gekauft"
    }
  ],
  "cart_purchasing": [
    {
      "type": 0,
      "value": "Kaufen"
    }
  ],
  "cart_sorry_charge_problem": [
    {
      "type": 0,
      "value": "Leider haben wir ein Problem festgestellt, daher ist diese Ladung nicht durchgegangen. Bitte versuchen Sie es erneut und kontaktieren Sie uns, wenn das Problem weiterhin besteht."
    }
  ],
  "cart_standard_price": [
    {
      "type": 0,
      "value": "Standardpreis ist "
    },
    {
      "type": 1,
      "value": "amount"
    },
    {
      "type": 0,
      "value": " pro Stück"
    }
  ],
  "cart_thank_you_purchase": [
    {
      "type": 0,
      "value": "Danke für deinen Einkauf!"
    }
  ],
  "cart_total": [
    {
      "type": 0,
      "value": "Gesamtbetrag"
    }
  ],
  "cart_unlock_all": [
    {
      "type": 0,
      "value": "Alle digitalen Bilder"
    }
  ],
  "cart_unlock_all_prints": [
    {
      "type": 0,
      "value": "Alle digitalen Bilder & Drucke"
    }
  ],
  "cart_unpurchased": [
    {
      "type": 0,
      "value": "Nicht gekauft"
    }
  ],
  "cart_view_photos": [
    {
      "type": 0,
      "value": "Fotos ansehen"
    }
  ],
  "cart_volume_discount_description": [
    {
      "type": 0,
      "value": "Kaufe "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Bild"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Bilder"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "quantity"
    },
    {
      "type": 0,
      "value": " und erhalte "
    },
    {
      "type": 1,
      "value": "percent"
    },
    {
      "type": 0,
      "value": " Rabatt"
    }
  ],
  "cart_volume_discount_label": [
    {
      "type": 1,
      "value": "percent"
    },
    {
      "type": 0,
      "value": " Rabatt auf "
    },
    {
      "type": 1,
      "value": "quantity"
    },
    {
      "type": 0,
      "value": " oder mehr"
    }
  ],
  "consumer_agreement": [
    {
      "type": 0,
      "value": "Durch die Nutzung von Capturelife stimmen Sie unseren "
    }
  ],
  "consumer_confirm_password": [
    {
      "type": 0,
      "value": "Passwort eingeben und bestätigen."
    }
  ],
  "consumer_confirm_your_password": [
    {
      "type": 0,
      "value": "Passwort bestätigen"
    }
  ],
  "consumer_contact_us": [
    {
      "type": 0,
      "value": "Kontaktieren Sie uns"
    }
  ],
  "consumer_email_or_phone": [
    {
      "type": 0,
      "value": "E-Mail oder Telefon"
    }
  ],
  "consumer_email_or_phone_long": [
    {
      "type": 0,
      "value": "E-Mail-Adresse oder Telefonnummer"
    }
  ],
  "consumer_email_placeholder": [
    {
      "type": 0,
      "value": "E-Mail-Adresse"
    }
  ],
  "consumer_enter_email": [
    {
      "type": 0,
      "value": "Bitte geben Sie eine E-Mail-Adresse ein."
    }
  ],
  "consumer_enter_password": [
    {
      "type": 0,
      "value": "Bitte geben Sie ein Passwort ein."
    }
  ],
  "consumer_enter_valid_email_phone": [
    {
      "type": 0,
      "value": "Bitte geben Sie eine gültige E-Mail-Adresse oder Telefonnummer ein."
    }
  ],
  "consumer_footer_text": [
    {
      "type": 0,
      "value": "WIZARDING WORLD und alle zugehörigen Marken, Charaktere, Namen und Indizien sind © & ™ Warner Bros. Entertainment Inc. Verlagsrechte © JKR. (s22)"
    }
  ],
  "consumer_forgot_password": [
    {
      "type": 0,
      "value": "Geben Sie Ihre E-Mail-Adresse oder Telefonnummer ein, um Ihr Passwort zurückzusetzen."
    }
  ],
  "consumer_forgot_your_password": [
    {
      "type": 0,
      "value": "Passwort vergessen?"
    }
  ],
  "consumer_image_view_print_store": [
    {
      "type": 0,
      "value": "Druckerei"
    }
  ],
  "consumer_item_generate_qr_code": [
    {
      "type": 0,
      "value": "QR-Code generieren"
    }
  ],
  "consumer_link_expired": [
    {
      "type": 0,
      "value": "Dieser Link ist leider abgelaufen. Bitte geben Sie Ihre E-Mail-Adresse oder Telefonnummer ein, um einen neuen Link zu erhalten."
    }
  ],
  "consumer_logging_in": [
    {
      "type": 0,
      "value": "Anmeldung läuft …"
    }
  ],
  "consumer_login_message": [
    {
      "type": 0,
      "value": "Ich möchte wieder Momente einfangen!"
    }
  ],
  "consumer_missing_something_error": [
    {
      "type": 0,
      "value": "Ups, du scheinst etwas vergessen zu haben."
    }
  ],
  "consumer_my_personal_data": [
    {
      "type": 0,
      "value": "Meine persönlichen Daten"
    }
  ],
  "consumer_nav_add_photos": [
    {
      "type": 0,
      "value": "Fotos hinzufügen"
    }
  ],
  "consumer_nav_add_photos_mobile": [
    {
      "type": 0,
      "value": "Hinzufügen"
    }
  ],
  "consumer_nav_back": [
    {
      "type": 0,
      "value": "Zurück"
    }
  ],
  "consumer_nav_download": [
    {
      "type": 0,
      "value": "Herunterladen"
    }
  ],
  "consumer_nav_home": [
    {
      "type": 0,
      "value": "Startseite"
    }
  ],
  "consumer_nav_logout": [
    {
      "type": 0,
      "value": "Abmelden"
    }
  ],
  "consumer_nav_news": [
    {
      "type": 0,
      "value": "Neuigkeiten"
    }
  ],
  "consumer_nav_print_store": [
    {
      "type": 0,
      "value": "Druckerei"
    }
  ],
  "consumer_nav_profile": [
    {
      "type": 0,
      "value": "Profil"
    }
  ],
  "consumer_nav_refresh": [
    {
      "type": 0,
      "value": "Aktualisieren"
    }
  ],
  "consumer_nav_share": [
    {
      "type": 0,
      "value": "Teilen"
    }
  ],
  "consumer_password_alteast_length": [
    {
      "type": 0,
      "value": "Ihr Passwort muss mindestens "
    },
    {
      "type": 1,
      "value": "count"
    },
    {
      "type": 0,
      "value": " Zeichen enthalten."
    }
  ],
  "consumer_password_placeholder": [
    {
      "type": 0,
      "value": "Passwort"
    }
  ],
  "consumer_passwords_dont_match": [
    {
      "type": 0,
      "value": "Ihr Passwort und die Passwortbestätigung stimmen nicht überein."
    }
  ],
  "consumer_qr_text": [
    {
      "type": 0,
      "value": "Bitte machen Sie einen Screenshot Ihres QR-Codes oder klicken Sie unten auf den Download-Button"
    }
  ],
  "consumer_reset_password": [
    {
      "type": 0,
      "value": "Passwort zurücksetzen"
    }
  ],
  "consumer_resetting_password": [
    {
      "type": 0,
      "value": "Passwort wird zurückgesetzt ..."
    }
  ],
  "consumer_retake_photo_button": [
    {
      "type": 0,
      "value": "Take a Photo"
    }
  ],
  "consumer_search_photo_button": [
    {
      "type": 0,
      "value": "Search for photos"
    }
  ],
  "consumer_select_all": [
    {
      "type": 0,
      "value": "Alle auswählen"
    }
  ],
  "consumer_selfie_button": [
    {
      "type": 0,
      "value": "Choose a selfie"
    }
  ],
  "consumer_selfie_instructions": [
    {
      "type": 0,
      "value": "Upload a selfie to get started"
    }
  ],
  "consumer_selfie_upload_complete": [
    {
      "type": 0,
      "value": "Selfie successfully uploaded"
    }
  ],
  "consumer_selfie_upload_failed": [
    {
      "type": 0,
      "value": "An error occurred.  Please try again"
    }
  ],
  "consumer_selfie_upload_in_progress": [
    {
      "type": 0,
      "value": "Upload in progress"
    }
  ],
  "consumer_share_dialog_notes": [
    {
      "type": 0,
      "value": "Um ein Bild herunterzuladen oder zu teilen, tippen Sie lange auf das Bild, um die Freigabeoptionen Ihres Geräts anzuzeigen."
    }
  ],
  "consumer_store_title": [
    {
      "type": 0,
      "value": "Online-Shop"
    }
  ],
  "consumer_take_photo_button": [
    {
      "type": 0,
      "value": "Take a Photo"
    }
  ],
  "consumer_terms_of_use": [
    {
      "type": 0,
      "value": "Nutzungsbedingungen"
    }
  ],
  "consumer_update_email": [
    {
      "type": 0,
      "value": "Bitte geben Sie die E-Mail-Adresse und das Passwort ein, die/das Sie verwenden möchten."
    }
  ],
  "consumer_update_password": [
    {
      "type": 0,
      "value": "Passwort aktualisieren"
    }
  ],
  "consumer_update_your_password": [
    {
      "type": 0,
      "value": "Aktualisieren Sie Ihr Passwort"
    }
  ],
  "consumer_updating_password": [
    {
      "type": 0,
      "value": "Passwort wird aktualisiert ..."
    }
  ],
  "consumer_welcome_back": [
    {
      "type": 0,
      "value": "Willkommen zurück!"
    }
  ],
  "error_coupon_minimum": [
    {
      "type": 0,
      "value": "Rabattcode kann nicht angewendet werden. Die Kaufsumme liegt unter dem Mindestbetrag"
    }
  ],
  "error_coupon_not_found": [
    {
      "type": 0,
      "value": "Rabattcode nicht gefunden"
    }
  ],
  "error_email_invalid": [
    {
      "type": 0,
      "value": "Bitte geben Sie eine gültige E-Mail-Adresse ein."
    }
  ],
  "error_email_required": [
    {
      "type": 0,
      "value": "Bitte geben Sie Ihre E-Mail-Adresse ein."
    }
  ],
  "error_fields_required": [
    {
      "type": 0,
      "value": "Bitte füllen Sie die folgenden Felder aus."
    }
  ],
  "error_reservation_not_found": [
    {
      "type": 0,
      "value": "Reservierung nicht gefunden."
    }
  ],
  "error_scan_band": [
    {
      "type": 0,
      "value": "Keine Bilder für dieses Konto. Bitte scanne ein Armband, das an der Fotostation verwendet wurde."
    }
  ],
  "error_see_attendant": [
    {
      "type": 0,
      "value": "Keine Fotos für dieses Konto. Bitte wenden Sie sich an einen Fotografen oder eine Mitarbeiter."
    }
  ],
  "form_label_credit_or_debit_card": [
    {
      "type": 0,
      "value": "Kredit- oder Debitkarte"
    }
  ],
  "form_label_customers_name": [
    {
      "type": 0,
      "value": "Customer's Name"
    }
  ],
  "form_label_email": [
    {
      "type": 0,
      "value": "E-Mail-Adresse"
    }
  ],
  "form_label_email_address": [
    {
      "type": 0,
      "value": "E-Mail-Adresse"
    }
  ],
  "form_label_last_name": [
    {
      "type": 0,
      "value": "Nachname"
    }
  ],
  "form_label_password": [
    {
      "type": 0,
      "value": "Passwort"
    }
  ],
  "form_label_pin": [
    {
      "type": 0,
      "value": "Pin"
    }
  ],
  "form_label_price": [
    {
      "type": 0,
      "value": "Preis (in "
    },
    {
      "type": 1,
      "value": "currency"
    },
    {
      "type": 0,
      "value": ")"
    }
  ],
  "form_label_room_number": [
    {
      "type": 0,
      "value": "Zimmernummer"
    }
  ],
  "form_label_secret_code": [
    {
      "type": 0,
      "value": "Geheimcode"
    }
  ],
  "form_label_select_all": [
    {
      "type": 0,
      "value": "Alle auswählen"
    }
  ],
  "form_label_unlock_all": [
    {
      "type": 0,
      "value": "Alle Bilder freischalten"
    }
  ],
  "kiosk_approval_form_header": [
    {
      "type": 0,
      "value": "Bestätigung Erforderlich"
    }
  ],
  "kiosk_approval_form_instructions": [
    {
      "type": 0,
      "value": "Bitte frage nach Unterstützung."
    }
  ],
  "kiosk_attendant_form_header": [
    {
      "type": 0,
      "value": "Kauf genehmigen"
    }
  ],
  "kiosk_attendant_form_instructions": [
    {
      "type": 0,
      "value": "Geben Sie den Preis für diesen Kauf ein."
    }
  ],
  "kiosk_auto_logout_subtitle": [
    {
      "type": 0,
      "value": "Du wirst automatisch in "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Sekunde"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Sekunden"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "count"
    },
    {
      "type": 0,
      "value": " ausgeloggt"
    }
  ],
  "kiosk_auto_logout_title": [
    {
      "type": 0,
      "value": "Hey, noch da?"
    }
  ],
  "kiosk_cart_count_verbose": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " digitale bild"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " digitales bilden"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "imageCount"
    },
    {
      "type": 0,
      "value": ", "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " ausdruck"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " ausdrucks"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "printCount"
    }
  ],
  "kiosk_cart_header": [
    {
      "type": 0,
      "value": "Überprüfen und kaufen"
    }
  ],
  "kiosk_cart_instructions": [
    {
      "type": 0,
      "value": "Tippen Sie auf "
    },
    {
      "children": [
      ],
      "type": 8,
      "value": "CloseIcon"
    },
    {
      "type": 0,
      "value": ", um ein Bild aus Ihrem Warenkorb zu entfernen. Tippen Sie auf "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "KAUF ABSCHLIESSEN"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": ", um fortzufahren."
    }
  ],
  "kiosk_catalog_header": [
    {
      "type": 0,
      "value": "Fügen Sie Bilder zu Ihrer Galerie hinzu"
    }
  ],
  "kiosk_catalog_header_no_gallery": [
    {
      "type": 0,
      "value": "Wählen Sie Bilder aus, die Sie kaufen möchten"
    }
  ],
  "kiosk_catalog_instructions": [
    {
      "type": 0,
      "value": "Tippen Sie auf Bilder, um sie zu Ihrer Galerie hinzuzufügen. Tippen Sie auf "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "MEINE GALERIE ANZEIGEN"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": ", um zu Ihrer Galerie zurückzukehren."
    }
  ],
  "kiosk_catalog_instructions_no_gallery": [
    {
      "type": 0,
      "value": "Tippen Sie auf Bilder, um sie Ihrer Bestellung hinzuzufügen. Tippen Sie auf "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "ÜBERPRÜFEN UND KAUFEN"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": ", um fortzufahren."
    }
  ],
  "kiosk_catalog_loading_message": [
    {
      "type": 0,
      "value": "Bilder werden geladen ..."
    }
  ],
  "kiosk_edit_moment_adjust_subject": [
    {
      "type": 0,
      "value": "Adjust Subject"
    }
  ],
  "kiosk_edit_moment_apply_changes": [
    {
      "type": 0,
      "value": "Apply Changes"
    }
  ],
  "kiosk_edit_moment_apply_overlay": [
    {
      "type": 0,
      "value": "Apply Overlay"
    }
  ],
  "kiosk_edit_moment_back": [
    {
      "type": 0,
      "value": "Back"
    }
  ],
  "kiosk_edit_moment_close_confirmation": [
    {
      "type": 0,
      "value": "All changes you have made will be discarded. Are you sure you want to continue?"
    }
  ],
  "kiosk_edit_moment_complete_edit": [
    {
      "type": 0,
      "value": "Complete Edit"
    }
  ],
  "kiosk_edit_moment_crop_image": [
    {
      "type": 0,
      "value": "Crop Image"
    }
  ],
  "kiosk_edit_moment_done": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "kiosk_edit_moment_next": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "kiosk_gallery_header": [
    {
      "type": 0,
      "value": "Auswählen und kaufen"
    }
  ],
  "kiosk_gallery_header_clubmed": [
    {
      "type": 0,
      "value": "Ihre Bildergalerie"
    }
  ],
  "kiosk_gallery_header_pre_print": [
    {
      "type": 0,
      "value": "Auswählen und drucken"
    }
  ],
  "kiosk_gallery_header_unlocked": [
    {
      "type": 0,
      "value": "Deine Bilder"
    }
  ],
  "kiosk_gallery_instructions": [
    {
      "type": 0,
      "value": "Tippe auf die Bilder, um sie für den Kauf auszuwählen. Tippe auf "
    },
    {
      "type": 1,
      "value": "boldText"
    },
    {
      "type": 0,
      "value": ", um fortzufahren."
    }
  ],
  "kiosk_gallery_instructions_empty_gallery": [
    {
      "type": 0,
      "value": "Ihre Galerie ist leer. Tippen Sie oben rechts auf dem Bildschirm auf "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "WEITERE BILDER"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": ", um verfügbare Bilder zu durchsuchen."
    }
  ],
  "kiosk_gallery_instructions_pre_print": [
    {
      "type": 0,
      "value": "Tippen Sie auf das Drucksymbol auf einem Bild, um es für den Druck auszuwählen. Tippen Sie auf den Schaltfläche „Drucken“, um die ausgewählten Bilder herunterzuladen."
    }
  ],
  "kiosk_gallery_instructions_prints": [
    {
      "type": 0,
      "value": "Tippe auf die Bilder, um sie für den Kauf auszuwählen. Tippe auf "
    },
    {
      "type": 1,
      "value": "boldText"
    },
    {
      "type": 0,
      "value": ", um fortzufahren."
    }
  ],
  "kiosk_gallery_instructions_unlocked": [
    {
      "type": 0,
      "value": "Sie haben alle Bilder freigeschaltet. Tippen Sie zum Entfernen aus Ihrer Galerie auf "
    },
    {
      "children": [
      ],
      "type": 8,
      "value": "CloseIcon"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "kiosk_gallery_instructions_unlocked_prints": [
    {
      "type": 0,
      "value": "Sie haben alle Bilder freigeschaltet. Tippen Sie auf ein Bild, um einen Druck anzufordern. Tippen Sie zum Entfernen aus Ihrer Galerie auf "
    },
    {
      "children": [
      ],
      "type": 8,
      "value": "CloseIcon"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "kiosk_image_tooltip_add_print": [
    {
      "type": 0,
      "value": "Druck hinzufügen"
    }
  ],
  "kiosk_image_tooltip_digital_purchased": [
    {
      "type": 0,
      "value": "Digitales Bild gekauft"
    }
  ],
  "kiosk_image_tooltip_print_purchased": [
    {
      "type": 0,
      "value": "Druck gekauft"
    }
  ],
  "kiosk_image_tooltip_print_selected": [
    {
      "type": 0,
      "value": "Ausgewählte Drucke"
    }
  ],
  "kiosk_image_tooltip_remove_print": [
    {
      "type": 0,
      "value": "Druck entfernen"
    }
  ],
  "kiosk_image_tooltip_select_print": [
    {
      "type": 0,
      "value": "Druck auswählen"
    }
  ],
  "kiosk_images_header": [
    {
      "type": 0,
      "value": "Deine Bilder"
    }
  ],
  "kiosk_images_header_clubmed": [
    {
      "type": 0,
      "value": "Bilder auswählen"
    }
  ],
  "kiosk_images_header_selected": [
    {
      "type": 0,
      "value": "Ihre Auswahl"
    }
  ],
  "kiosk_login_header_access_your_images": [
    {
      "type": 0,
      "value": "Gelange zu deinen Bildern"
    }
  ],
  "kiosk_login_header_clubmed": [
    {
      "type": 0,
      "value": "Geben Sie Ihre Zimmernummer, Ihren Nachnamen und Ihre E-Mail-Adresse ein, um auf Ihre Galerie zuzugreifen."
    }
  ],
  "kiosk_login_header_preprint": [
    {
      "type": 0,
      "value": "Pre-Print Gallery"
    }
  ],
  "kiosk_login_header_welcome": [
    {
      "type": 0,
      "value": "Herzlich willkommen!"
    }
  ],
  "kiosk_login_hpx_footer_text": [
    {
      "type": 0,
      "value": "WIZARDING WORLD and all related trademarks, characters, names, and indicia are © & ™ Warner Bros. Entertainment Inc. Publishing Rights © JKR. (s22)"
    }
  ],
  "kiosk_login_instructions_enter_email": [
    {
      "type": 0,
      "value": "Bitte geben Sie Ihre E-Mail-Adresse ein, um fortzufahren."
    }
  ],
  "kiosk_login_instructions_scan_band": [
    {
      "type": 0,
      "value": "Scanne dein Armband, um zu beginnen."
    }
  ],
  "kiosk_offsite_pos_form_bill_to_room_header": [
    {
      "type": 0,
      "value": "Aufs Zimmer schreiben"
    }
  ],
  "kiosk_offsite_pos_form_bill_to_room_instructions": [
    {
      "type": 0,
      "value": "Der folgende Gesamtbetrag wird auf Ihr Zimmer geschrieben."
    }
  ],
  "kiosk_offsite_pos_form_generic_header": [
    {
      "type": 0,
      "value": "Kauf Abschließen"
    }
  ],
  "kiosk_offsite_pos_form_generic_instructions": [
    {
      "type": 0,
      "value": "Deine Bestellung enthält:"
    }
  ],
  "kiosk_order_details_disclaimer_no_refunds": [
    {
      "type": 0,
      "value": "* Alle Verkäufe sind endgültig und können nicht zurückerstattet werden."
    }
  ],
  "kiosk_order_details_header": [
    {
      "type": 0,
      "value": "Bestelldetails"
    }
  ],
  "kiosk_order_details_instructions": [
    {
      "type": 0,
      "value": "Tippen Sie links auf die Bilder, die Sie kaufen möchten."
    }
  ],
  "kiosk_order_details_instructions_cart_empty": [
    {
      "type": 0,
      "value": "Ihr Warenkorb ist leer. Tippen Sie auf Bilder, um sie Ihrer Bestellung hinzuzufügen."
    }
  ],
  "kiosk_order_details_instructions_cart_empty_more_images": [
    {
      "type": 0,
      "value": "Ihr Warenkorb ist leer. Tippen Sie auf "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "WEITERE BILDER HINZUFÜGEN"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": ", um weitere Bilder hinzuzufügen."
    }
  ],
  "kiosk_order_details_instructions_email": [
    {
      "type": 0,
      "value": "Sie erhalten Ihre Bilder per E-Mail."
    }
  ],
  "kiosk_order_details_instructions_prints": [
    {
      "type": 0,
      "value": "Doppeltippen Sie auf ein Bild, um einen Druck anzufordern."
    }
  ],
  "kiosk_order_details_line_item_digitals": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Digitale Bild"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Digitales Bilder"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "quantity"
    }
  ],
  "kiosk_order_details_line_item_prints": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Ausdruck"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Ausdrucks"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "quantity"
    }
  ],
  "kiosk_order_details_total": [
    {
      "type": 0,
      "value": "Gesamtbetrag:"
    }
  ],
  "kiosk_payment_method_form_header": [
    {
      "type": 0,
      "value": "Kauf Abschließen"
    }
  ],
  "kiosk_payment_method_form_instructions": [
    {
      "type": 0,
      "value": "Wie möchten Sie Ihren Kauf abschließen?"
    }
  ],
  "kiosk_price_guide_header": [
    {
      "type": 0,
      "value": "Preisübersicht"
    }
  ],
  "kiosk_price_guide_instructions": [
    {
      "type": 0,
      "value": "Mehr Bilder kaufen und Rabatt erhalten"
    }
  ],
  "kiosk_price_guide_instructions_standard_price": [
    {
      "type": 0,
      "value": "Standardpreis ist "
    },
    {
      "type": 1,
      "value": "price"
    },
    {
      "type": 0,
      "value": " pro Bild"
    }
  ],
  "kiosk_price_guide_instructions_unlocked": [
    {
      "type": 0,
      "value": "Sie können kostenlos weitere Bilder hinzufügen"
    }
  ],
  "kiosk_print_size_edits_cancel": [
    {
      "type": 0,
      "value": "Cancel"
    }
  ],
  "kiosk_print_size_edits_continue": [
    {
      "type": 0,
      "value": "Continue"
    }
  ],
  "kiosk_print_size_edits_create": [
    {
      "type": 0,
      "value": "Create"
    }
  ],
  "kiosk_print_size_select_header": [
    {
      "type": 0,
      "value": "Druckgrößen"
    }
  ],
  "kiosk_print_size_select_instructions": [
    {
      "type": 0,
      "value": "Druckgröße und Anzahl auswählen"
    }
  ],
  "kiosk_processing_edited_moment": [
    {
      "type": 0,
      "value": "Processing edited moment..."
    }
  ],
  "kiosk_processing_payment": [
    {
      "type": 0,
      "value": "Zahlung wird bearbeitet …"
    }
  ],
  "kiosk_purchase_details_discounts_offered": [
    {
      "children": [
        {
          "type": 0,
          "value": "Angebotene Rabatte:"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "kiosk_purchase_details_packages_offered": [
    {
      "children": [
        {
          "type": 0,
          "value": "Angebotene Pakete:"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "kiosk_purchase_details_per_image": [
    {
      "type": 1,
      "value": "price"
    },
    {
      "type": 0,
      "value": " pro Bild"
    }
  ],
  "kiosk_purchase_details_standard_price": [
    {
      "children": [
        {
          "type": 0,
          "value": "Standardpreis:"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "kiosk_purchase_details_total": [
    {
      "children": [
        {
          "type": 0,
          "value": "Gesamt:"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "kiosk_purchase_disabled_instructions": [
    {
      "type": 0,
      "value": "Tippe auf die Bilder, um sie für den Kauf auszuwählen."
    }
  ],
  "kiosk_purchase_disabled_instructions_more_images": [
    {
      "type": 0,
      "value": "Tippen Sie auf Bilder, um sie zum Kaufen auszuwählen oder die Auswahl aufzuheben. Um weitere Bilder aus Ihrer Auswahl hinzuzufügen, tippen Sie auf "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "WEITERE BILDER"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "kiosk_reader_not_connected": [
    {
      "type": 0,
      "value": "Reader nicht verbunden"
    }
  ],
  "kiosk_reader_payment_failed": [
    {
      "type": 0,
      "value": "Reader konnte nicht verarbeiten"
    }
  ],
  "kiosk_reader_standby": [
    {
      "type": 0,
      "value": "Reader im Standby-Modus ..."
    }
  ],
  "kiosk_receipt_header": [
    {
      "type": 0,
      "value": "Kauf abgeschlossen"
    }
  ],
  "kiosk_receipt_instructions": [
    {
      "type": 0,
      "value": "Ein Link zu deiner digitalen Galerie wurde an "
    },
    {
      "type": 1,
      "value": "email"
    },
    {
      "type": 0,
      "value": " geschickt."
    }
  ],
  "kiosk_remove_modal_instructions": [
    {
      "type": 0,
      "value": "Möchten Sie dieses Bild aus Ihrer Bestellung entfernen? Sie müssen es erneut suchen, indem Sie auf "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "WEITERE BILDER HINZUFÜGEN"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " tippen."
    }
  ],
  "kiosk_room_dialog_header": [
    {
      "type": 0,
      "value": "Zimmer "
    },
    {
      "type": 1,
      "value": "room"
    }
  ],
  "kiosk_room_dialog_header_multiple": [
    {
      "type": 0,
      "value": "Zimmer "
    },
    {
      "type": 1,
      "value": "rooms"
    }
  ],
  "kiosk_room_dialog_instructions_link_sent": [
    {
      "type": 0,
      "value": "Ein Link zu deiner digitalen Galerie wurde an "
    },
    {
      "type": 1,
      "value": "email"
    },
    {
      "type": 0,
      "value": " geschickt."
    }
  ],
  "kiosk_selected_print_size": [
    {
      "type": 0,
      "value": "Print Size"
    }
  ],
  "kiosk_selected_print_sizes_aspect_column": [
    {
      "type": 0,
      "value": "Seitenverhältnis"
    }
  ],
  "kiosk_selected_print_sizes_header": [
    {
      "type": 0,
      "value": "Ausgewählte Drucke"
    }
  ],
  "kiosk_selected_print_sizes_photo_column": [
    {
      "type": 0,
      "value": "Moment"
    }
  ],
  "kiosk_selected_print_sizes_quantity_column": [
    {
      "type": 0,
      "value": "Anzahl"
    }
  ],
  "kiosk_selected_print_sizes_size_column": [
    {
      "type": 0,
      "value": "Druckgröße"
    }
  ],
  "kiosk_stripe_form_header": [
    {
      "type": 0,
      "value": "Kauf Abschließen"
    }
  ],
  "kiosk_stripe_form_header_clubmed": [
    {
      "type": 0,
      "value": "Zahlungsinformationen eingeben"
    }
  ],
  "kiosk_topbar_welcome_message": [
    {
      "type": 0,
      "value": "Willkommen, "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "name"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "!"
    }
  ],
  "kiosk_welcome_message": [
    {
      "type": 0,
      "value": "Willkommen, "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "name"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "!"
    }
  ]
}